import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {UtilsService} from '../../../../core/utils/utils.service';
import {DialogMsgSupplier} from '../../../../core/suppliers/dialog-msg-supplier';
import {FournisseurDTO} from '../../../../core/dtos/fournisseur-d-t-o';
import {FournisseurService} from '../../../../core/services/entities/fournisseur.service';
import {GestionFournisseurService} from '../../../../core/services/gestion-fournisseurs/gestion-fournisseur.service';
import {AdresseDTO} from '../../../../core/dtos/adresse-dto';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {SiteDTO} from "../../../../core/dtos/site-dto";
import {SecteursService} from "../../../../core/services/entities/secteurs.service";
import {SecteurDTO} from "../../../../core/dtos/secteur-dto";
import {TagBoxComponent} from "../../../../shared/ui/tag-box/tag-box.component";
import {LookUpComponent} from "../../../../shared/ui/lookup/lookup.component";
import {SecteurFournisseurDTO} from "../../../../core/dtos/secteurfournisseur-dto";
import {NgForm} from "@angular/forms";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {Subject} from "rxjs";
import {GraphQLService} from "../../../../core/services/technique/graphql.service";
import {DepartementDTO} from "../../../../core/dtos/departement-dto";
import {takeUntil} from "rxjs/operators";
import {confirm} from "devextreme/ui/dialog";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-fournisseur-fiche-identite',
    templateUrl: './fournisseur-fiche-identite.component.html',
    styleUrls: ['./fournisseur-fiche-identite.component.scss'],
    standalone: false
})
export class FournisseurFicheIdentiteComponent implements OnInit, OnDestroy {
  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @ViewChild("secteursTagbox") secteursTagBox: TagBoxComponent;
  @ViewChild("siteLookup") siteLookup: LookUpComponent;
  @ViewChild("fournisseurForm") fournisseurForm!: NgForm;
  create: boolean = true;
  fullScreen: boolean = true;
  selectedSite: number;
  selectedSecteurs: number[];
  sitesList: SiteDTO[];
  secteursList: SecteurDTO[];
  fournisseur: FournisseurDTO;
  departementList: DepartementDTO[];
  departementListEnriched: any[] = [];

  pathFile: string = HELP_FOLDERS.FOURNISSEURS + '/fournisseur-edition';

  selectedDepartements: number[] = [];

  private destroy$ = new Subject<void>();

  constructor(public fournisseurSvc: FournisseurService,
              public gestionFournisseurScv: GestionFournisseurService,
              public utils: UtilsService,
              private toastSvc: ToastService,
              private secteurSvc: SecteursService,
              private auth2Svc: Auth2Service,
              private graphQlSvc: GraphQLService,
              @Inject('dynamicData') public fournisseurData: FournisseurDTO) {
  }

  ngOnInit() {
    this.initSecteurs();
    this.initSites();

    // Attendre la fin de la requête asynchrone avant de lancer Fournisseur
    this.initDepartements().pipe(
      takeUntil(this.destroy$)
    ).subscribe(item => {
      this.departementList = item.allDepartement;
      this.departementListEnriched = [...this.departementList]
        .sort((a, b) => a.code.localeCompare(b.code))
        .map(dep => ({...dep, regionNom: dep.region?.nom, regionCode: dep.region?.code, nom: `${dep.code} - ${dep.nom}`}));
      this.initFournisseur();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initDepartements = () => {
    return this.graphQlSvc.sendQuery(`
      {
        allDepartement {
          id,
          code,
          nom,
          region {
            id,
            code,
            nom
          }
        }
      }
    `);
  }

  saveFicheIdentite = async () => {
    this.fournisseur.adresse.entityName = this.fournisseurSvc.getEntityName();
    const fournisseurClean = this.getFournisseurClean();
    fournisseurClean.secteurFournisseurList = [];

    fournisseurClean.secteurFournisseurList = this.secteursTagBox.getSelectedItems().map(secteur => new SecteurFournisseurDTO(this.fournisseur.id, secteur));

    if (this.create)
      fournisseurClean.site = this.utils.getLightSite(this.siteLookup.getSelectedItem())

    let res = false;
    if(!this.create && this.selectedDepartements?.length) {
      const question = 'Souhaitez-vous réinitialiser tous les départements au niveau des articles associés à ce fournisseur ?';
      res = await confirm(question, "Mise à jour des articles associés");
    }

    this.gestionFournisseurScv.saveFournisseur(fournisseurClean, res).subscribe(response => {

      if (!this.utils.isResponseSupplierError(response)) {
        //this.fournisseur = fournisseurClean;
        this.fournisseur.code = response.one.code;
        this.fournisseur.id = response.one.id;
        this.fournisseur.dateCreation = response.one.dateCreation;
        this.fournisseur.dateDerniereModification = response.one.dateDerniereModification;
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Enregistrement du fournisseur "${this.fournisseur.libelle.toUpperCase()}" réalisé avec succès`);

        // annoncer que la fiche d'identite a été sauvegardée. La grille des unites de prod doit être abonnée pour faire la mise à jour
        this.gestionFournisseurScv.announceRefreshGrid(this.fournisseur);
        // mise à jour de la liste des menus
        this.gestionFournisseurScv.announceFournisseur(this.fournisseur);
      }
    });
  }

  isFormValid = (): boolean => {
    if (this.create)
      return this.siteLookup?.getSelectedItem() && this.secteursTagBox?.getSelectedItems().length !== 0 && this.fournisseurForm?.valid;
    else
      return this.secteursTagBox?.getSelectedItems().length !== 0 && this.fournisseurForm?.valid;
  }

  help = (): DialogMsgSupplier => undefined;

  private initFournisseur = (): void => {
    this.fournisseur = this.fournisseurData;
    this.create = !(this.fournisseurData.id !== 0);
    if (this.create) {
      this.fournisseur.francoDePortCout = 0;
      this.fournisseur.francoDePortTva = 20;
      this.fournisseur.actif = true;
      this.fournisseur.francoDePortActif = false;
      this.fournisseur.adresse = new AdresseDTO(null, 0);
    } else {
      this.initSelectedSecteurs();
      this.initSelectedDepartements();
      this.selectedSite = this.fournisseur.site.id;
    }
  }

  private getFournisseurClean = () => {
    return JSON.parse(JSON.stringify(this.fournisseur))
  }

  private initSelectedSecteurs = (): void => {
    this.selectedSecteurs = this.fournisseur.secteurFournisseurList.map(secteur => secteur.secteur.id);
  }

  private initSelectedDepartements = (): void => {
    this.fournisseur.departements = this.departementList.filter(item =>
      this.fournisseur.departements.find(item2 => item2.id == item.id));
    this.selectedDepartements = this.fournisseur.departements.map(dep => dep.id);
  }

  initSites = (): void => {
    this.secteurSvc.getAllFromEnvironnement();
    this.sitesList = this.auth2Svc.utilisateur.siteListLocaux;
  };

  private initSecteurs = (): void => {
    this.secteursList = this.secteurSvc.secteurEnvironnement;
  }

  canEdit = () => {
    return this.create || this.auth2Svc.isSiteLocal(this.fournisseur.site.id);
  };

  groupDepartementByRegion = (dep: DepartementDTO): string => dep.region.nom;

  onDepartementsChange = (selectedIds: number[]): void => {
    this.selectedDepartements = selectedIds.length ? selectedIds : null;
    this.fournisseur.departements = selectedIds.length
      ? this.departementList.filter(dep => selectedIds.find(id => id === dep.id))
      : null;
  };
}
